import { bannerControllerGetBanner } from "@/shared/api/generated"
import { useQuery } from "@tanstack/react-query"

/**
 * The owner's announcement banner (admin bot). Read again every 5 minutes while the tab is
 * visible and when it comes back to the front, so a banner published while someone has the app
 * open reaches them without a reload (the native apps do the same).
 */
export function useGetBanner() {
	return useQuery({
		queryFn: bannerControllerGetBanner,
		queryKey: ["BANNER"],
		staleTime: 60_000,
		gcTime: 24 * 60 * 60_000,
		refetchOnMount: false,
		refetchOnWindowFocus: true,
		refetchInterval: 5 * 60_000,
		refetchIntervalInBackground: false,
	})
}
